import styled, { keyframes, css } from "styled-components";

const tagShimmer = keyframes`
    0% {
        left: 0%;
    }
    66%, 100% {
        left: 110%;
    }
`;

export const Parent = styled.div`
    position: relative;
    display: flex;
`;

export const NewTag = styled.span<{ $skipShimmer: boolean }>`
    text-align: center;
    padding: 2px 6px;
    color: ${props => props.theme.colors[props.theme.colorMode].background_Primary};
    position: relative;
    background: ${props => props.theme.colors[props.theme.colorMode].primary};
    border-radius: ${props => props.theme.cornerRadius.xxSmall};
    text-transform: uppercase;
    overflow: hidden;

    ${props =>
        !props.$skipShimmer &&
        css`
            &::after {
                content: "";
                position: absolute;
                top: 0;
                width: 6px;
                height: 100%;
                opacity: 0.3;
                transform: skewX(-40deg);
                background-color: ${props.theme.colors[props.theme.colorMode].background_Primary};
                animation: ${tagShimmer} 2s infinite;
                will-change: left;
            }
        `}

    ${props =>
        props.$skipShimmer &&
        css`
            &::after {
                display: none;
            }
        `}
`;
